export enum Roles {
    User = 'USER',
    EventCreator = 'EVENT_CREATOR',
    Developer = 'DEVELOPER'
}
